import { combineReducers } from 'redux'
import settings from './settings'
import errors from './errors'
import annualPassHolders from './annualPassHolders'
import annualPassTypes from './annualPassTypes'
import memberPassHolders from './memberPassHolders'
import memberPassTypes from './memberPassTypes'
import seasonPassHolders from './seasonPassHolders'
import seasonPassTypes from './seasonPassTypes'

const reducers = combineReducers({
  settings,
  errors,
  annualPassHolders,
  annualPassTypes,
  memberPassHolders,
  memberPassTypes,
  seasonPassHolders,
  seasonPassTypes
})

const rootReducer = (state, action) => {
  if (action.type === 'SET_USER') {
    state = undefined
  }
  return reducers(state, action)
}

export default rootReducer
